/* ============ SportFox Theme — global.js ============ */
(function () {
  "use strict";

  function money(cents) {
    var v = (cents / 100).toFixed(2).replace(".", ",").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    return "R$ " + v;
  }

  function updateCartCount(count) {
    document.querySelectorAll("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? "grid" : "none";
    });
  }

  // ---- Add to cart (AJAX) ----
  function bindAddToCart() {
    document.addEventListener("submit", function (e) {
      var form = e.target.closest("form[data-product-form]");
      if (!form) return;
      e.preventDefault();
      var btn = form.querySelector("[type=submit]");
      var original = btn ? btn.textContent : "";
      if (btn) { btn.disabled = true; btn.textContent = "Adicionando..."; }

      fetch(window.SportFox.routes.cart_add, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [{ id: form.querySelector("[name=id]").value, quantity: parseInt(form.querySelector("[name=quantity]") ? form.querySelector("[name=quantity]").value : 1, 10) }]
        })
      })
        .then(function (r) { return r.json(); })
        .then(function () { return fetch(window.SportFox.routes.cart + ".js"); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          if (btn) { btn.textContent = "Adicionado ✓"; }
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = original; } }, 1600);
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = original; }
          window.location.href = window.SportFox.routes.cart;
        });
    });
  }

  // ---- Quantity steppers ----
  function bindQty() {
    document.addEventListener("click", function (e) {
      var b = e.target.closest("[data-qty]");
      if (!b) return;
      var input = b.parentElement.querySelector("input");
      if (!input) return;
      var val = parseInt(input.value, 10) || 1;
      val += b.getAttribute("data-qty") === "up" ? 1 : -1;
      if (val < 1) val = 1;
      input.value = val;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  // ---- Variant selection updates hidden id + price ----
  function bindVariants() {
    document.querySelectorAll("[data-variant-selects]").forEach(function (root) {
      var data = JSON.parse(root.getAttribute("data-variants") || "[]");
      var idInput = root.querySelector("[name=id]");
      var priceEl = document.querySelector("[data-pdp-price]");
      var selects = root.querySelectorAll("select[data-option]");
      function refresh() {
        var chosen = Array.prototype.map.call(selects, function (s) { return s.value; });
        var match = data.find(function (v) { return JSON.stringify(v.options) === JSON.stringify(chosen); });
        if (match) {
          if (idInput) idInput.value = match.id;
          if (priceEl) priceEl.firstChild.textContent = money(match.price) + " ";
          var btn = root.querySelector("[type=submit]");
          if (btn) { btn.disabled = !match.available; btn.textContent = match.available ? "Adicionar ao carrinho" : "Esgotado"; }
        }
      }
      selects.forEach(function (s) { s.addEventListener("change", refresh); });
    });
  }

  // ---- Mobile menu ----
  function bindMenu() {
    var toggle = document.querySelector(".menu-toggle");
    var nav = document.querySelector(".mobile-nav");
    if (!toggle || !nav) return;
    toggle.addEventListener("click", function () { nav.classList.toggle("open"); });
  }

  // ---- Cart line quantity change (cart page) ----
  function bindCartChange() {
    document.querySelectorAll("[data-cart-qty]").forEach(function (input) {
      input.addEventListener("change", function () {
        var line = input.getAttribute("data-line");
        fetch(window.SportFox.routes.cart + "/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(input.value, 10) })
        }).then(function () { window.location.reload(); });
      });
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    updateCartCount(window.SportFox.cartCount || 0);
    bindAddToCart();
    bindQty();
    bindVariants();
    bindMenu();
    bindCartChange();
  });
})();
